import { from, map } from 'rxjs';
import { HashCreator, HashUint8Array } from '../../utils/cargo-driver-check-in-service/const';

export const createHashUint8Array: HashCreator = (message: string) => {
    const encoder = new TextEncoder();
    const msgUint8 = encoder.encode(message);

    return from(crypto.subtle.digest('SHA-256', msgUint8))
        .pipe(
            map(hashBuffer =>
                new HashUint8Array(new Uint8Array(hashBuffer))
            )
        );
};